import React from "react";
import "./Environmental.css";
import environmentalImage from "../assets/images/solor.jpg";
import circularImage from "../assets/images/circular-economy.jpg";

const Environmental = () => {
  return (
    <>
      {/* ================= HERO ================= */}
      <section
        className="environmental-hero"
        style={{ backgroundImage: `url(${environmentalImage})` }}
      >
        <div className="environmental-hero-overlay" />

        <div className="environmental-hero-content">
          <h1 className="environmental-hero-title">
            <span className="green">Moving towards</span>{" "}
            <span className="purple">a sustainable future</span>
          </h1>
        </div>
      </section>
      {/* ================= ENVIRONMENTAL METRICS ================= */}
<section className="env-metrics-section">
  <div className="env-metrics-grid">

    {/* LEFT TITLE */}
    <div className="env-metrics-title">
      <h2>
        <span className="green">Environmental</span>
        <br />
        <span className="purple">care moves us</span>
      </h2>
    </div>

    {/* METRIC 1 */}
    <div className="env-metric-card green-border">
      <div className="env-icon">☀️</div>
      <p>
        A <strong>15,000 m²</strong> solar farm that generates{" "}
        <strong>2.5 times the energy needs of our central offices</strong>.
      </p>
    </div>

    {/* METRIC 2 */}
    <div className="env-metric-card purple-border">
      <div className="env-icon">⚡</div>
      <p>
        <strong>100% green electricity</strong> at our medicine manufacturing
        plants.
      </p>
    </div>

    {/* METRIC 3 */}
    <div className="env-metric-card green-border">
      <div className="env-icon">🌱</div>
      <p>
        Over the last four years, <strong>Cinfa Group</strong> has reduced the
        intensity ratio of its <strong>carbon footprint by 57%</strong>.
      </p>
    </div>

  </div>
</section>
{/* ================= CIRCULAR ECONOMY ================= */}
<section className="circular-section">
  <div className="circular-grid">

    {/* LEFT: IMAGE + CAPTIONS */}
    <div className="circular-left">
      <img
        src={circularImage}
        alt="Circular economy and eco-packaging"
        className="circular-image"
      />

      <div className="circular-captions">
        <p>
          The boxes we use to ship our orders are made of{" "}
          <strong>100% recycled cardboard</strong>.
        </p>
        <p>
          <strong>40 tonnes</strong> of cardboard saved every year under our
          medicine pack density reduction project.
        </p>
      </div>
    </div>

    {/* RIGHT: CONTENT */}
    <div className="circular-right">
      <h2 className="circular-title">
        <span className="green">Circular</span>{" "}
        <span className="purple">economy</span>
      </h2>

      <div className="circular-highlight">
        <span className="circular-percent">77%</span>
        <p>
          <strong>of the waste</strong> from Cinfa Group is subject to{" "}
          <strong>repurposing</strong> processes.
        </p>
      </div>

      <div className="circular-divider" />

      <h3 className="circular-subtitle">
        <span className="green">Eco-packaging:</span>
      </h3>

      <p>
        We seek to optimise the design and consumption of material in our
        packaging, as well as to guarantee sustainable sources and a smaller
        environmental impact.
      </p>
    </div>

  </div>
</section>
{/* ================= COMMITMENTS ================= */}
<section className="commitments-section">
  <h2 className="commitments-title">
    <span className="green">Our</span>{" "}
    <span className="purple">commitments</span>
  </h2>

  <div className="commitments-list">
    <span className="commitment-pill green-border">People move us</span>
    <span className="commitment-pill purple-border">Ethics and transparency</span>
    <span className="commitment-pill green-border">Environmental commitment</span>
    <span className="commitment-pill purple-border">
      Sustainable economic development
    </span>
  </div>
</section>
    </>
  );
};

export default Environmental;